import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

export const ImageContainer = styled('div')({
  display: 'inline-block',
  width: '100%',
  height: '70%'
});

export const ImageStyle = styled('div')({
  display: 'inline-block',
  width: '241px',
  height: '216px',
  marginLeft: 'calc(50% - 120.5px)',
  marginTop: '5%'
});

export const ImageTypography = styled(Typography)({
  fontFamily: 'Open Sans',
  fontsize: '24px',
  marginTop: '15px',
  marginLeft: 'calc(50% - 75px)'
});
